<div
  class="breathing-dot-inner"
  [class.is-paused]="isPaused()"
></div>
